<template>
  <div class="header">
    <div class="main-content">
      <img src="../assets/logo.png" alt="logo">
      <div class="nav">
        <router-link
          class="nav-item"
          v-for="(item, index) in navList"
          :to="item.path"
          :key="index"
        >{{item.name}}</router-link>
      </div>
      <div class="userMenu">
        <a-dropdown placement="bottomRight">
          <a class="ant-dropdown-link" href="#">
            <div class="user-bg">
              <a-icon class="user-icon" type="user"/>
            </div>
          </a>
          <a-menu slot="overlay" class='headerMenu'>
            <a-menu-item>
              <a href="javascript:;">{{phone}}</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="exit">退出登录</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navList: [
        {
          name: "录入订单",
          path: "/enterOrder"
        },
        {
          name: "我的订单",
          path: "/myOrder"
        }
      ],
      phone:''
    };
  },
  created(){
    this.phone = this.$cookie.get('is_login');
  },
  methods:{
    exit(){
      axios({
        url:'/api/workOrder/loginOut',
        method:'POST',
      }).then(res=>{
        this.$cookie.delete('is_login');
        this.$router.push('/login');
      })
    }
  }
};
</script>
<style scoped>
.header{
  position: fixed;
  width: 100%;
  z-index: 10;
  top: 0;
  background: #FFF;
}
.header,
.main-content {
  display: flex;
  align-items: center;
  height: 66px;
}
.header {
  justify-content: center;
}
.main-content {
  width: 1461px;
  position: relative;
}
.nav {
  margin-left: 61px;
}
.nav-item {
  display: inline-block;
  text-align: center;
  line-height: 66px;
  width: 108px;
  height: 66px;
  color: #303445;
}
.nav-item.router-link-active {
  background: rgba(48, 145, 242, 1);
  color: #fff;
  text-decoration: none;
}
.userMenu {
  position: absolute;
  right: 0;
}
.user-bg{
    width: 66px;
    height: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.user-icon {
  border-radius: 50%;
  font-size: 26px;
  border: 2px solid #59607b;
  color: #59607b;
}
.headerMenu{
  width: 150px;
  height: 110px;
  font-size: 12px;
}
.headerMenu>li{
  height: 50px;
  line-height: 40px;
}
</style>
